import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useFieldArray } from "react-hook-form";
import styles from "./FieldArray.module.scss";
import Button from "@/components/Button/Button";
import DeleteIcon from "@/components/SVGComponents/DeleteIcon";
import { Input } from "../Input/Input";
import withLabelAndError from "../withLabelAndError";
import { getInitialValues } from "@/lib/utils";

let updated = false;

const FieldArray = (props: any) => {
  const { control, name, slabFields } = props;
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const inputRef = useRef(null);

  const addSlab = () => {
    updated = true;
    append(getInitialValues(slabFields));
  };

  const handleRemove = (index: any) => () => {
    updated = true;
    remove(index);
  };

  useEffect(() => {
    if (inputRef?.current && updated) {
      inputRef?.current?.focus?.();
    }
  }, [fields]);

  useEffect(() => {
    return () => {
      updated = false;
    };
  }, []);

  return (
    <div className={styles.fieldArrayWrapper}>
      {fields.map((item, index) => {
        const lastSlab = index === fields.length - 1;
        return (
          <div key={item.id} className={styles.slabRow}>
            <div className={styles.heading}>
              <p>Slab {index + 1}</p>
              {lastSlab && (
                <DeleteIcon onClick={handleRemove(index)} height={16} />
              )}
            </div>
            <div className={styles.fields}>
              {Object.entries(slabFields).map(
                ([fieldName, fieldProps], slabFieldIndex) => {
                  return (
                    <Input
                      key={fieldName}
                      {...(lastSlab && slabFieldIndex === 0
                        ? { ref: inputRef }
                        : {})}
                      name={`${name}[${index}][${fieldName}]`}
                      control={control}
                      type={fieldProps.controlType}
                      placeholder={
                        fieldProps?.placeholder || `Enter ${fieldProps.label}`
                      }
                    />
                  );
                }
              )}
            </div>
          </div>
        );
      })}
      <Button type="button" onClick={addSlab} className={styles.addBtn}>
        Add Slab
      </Button>
    </div>
  );
};

// ✅ PropTypes validation for SonarQube
FieldArray.propTypes = {
  control: PropTypes.any.isRequired, // ideally shape of react-hook-form Control
  name: PropTypes.string.isRequired,
  // slabFields is an object with keys and props (controlType, label, placeholder etc.)
  slabFields: PropTypes.objectOf(
    PropTypes.shape({
      controlType: PropTypes.string.isRequired,
      label: PropTypes.string,
      placeholder: PropTypes.string,
    })
  ).isRequired,
};

const FieldArrayWithLabelAndError = withLabelAndError(FieldArray);

export default FieldArrayWithLabelAndError;
export { FieldArray };
